<template>
  <div :class="[{'fy-form-item-inline':is_inline}]" :style="style_obj" class="fy-form-item">
    <label
      :class="[{'fy-required-label':requiredLabelData}]"
      :for="prop"
      class="fy-form-item-label"
      v-if="label"
    >{{ label }}</label>
    <div
      :class="[{'fy-error-form-item-content':validateMessage},{'fy-is-success':isSuccess}]"
      :style="inner_style_obj"
      class="fy-form-item-content"
    >
      <slot></slot>
      <label
        :class="[{'fy-error-popup':styleTypeError==1 || styleTypeError==2},{'fy-error-popup-right':styleTypeError==2},{'fy-error-fixation':styleTypeError==3}]"
        v-if="isShowErrot"
      >{{validateMessage}}</label>
    </div>
  </div>
</template>
<script>
/**
 * 以下vc是vue组件的简称
 */
import AsyncValidator from 'async-validator'
import util from '../utils/util.js'
export default {
  name: 'fy-form-item',
  componentName: 'FyFormItem',
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）
  provide () {
    return {
      fyFormItem: this
    }
  },
  inject: ['fyForm'],
  data () {
    return {
      isShowErrot: false,
      style_obj: {}, //fy-form-item自定义样式（只有为行内类型的时候才支持自定义样式）
      inner_style_obj: {}, //内部元素自定义样式（只有为行内类型的时候才支持自定义样式）
      validateMessage: '', //错误消息
      validateDisabled: false, //用于清除所有验证时做判断,执行清除操作后设置为true，不执行下一次onchange事件
      isSuccess: false, //是否严重成功
      styleTypeError:
        this.errorStyleType === undefined ||
          this.errorStyleType === null
          ? this.$defines.errorType
          : this.errorStyleType, //错误提示样式：1:悬浮提示上方  2:悬浮提示右侧  3:固定组件下方提示
      childVc: Object, //子组件对象（componentName）
      requiredLabelData: this.required_label //判断是否必填
    }
  },
  props: {
    //设置错误提示的样式：1:悬浮提示上方  2:悬浮提示右侧  3:固定组件下方提示
    errorStyleType: {
      type: Number,
      default: null
    },
    //是否必填
    required_label: {
      type: Boolean,
      default: false
    },
    label: String,
    prop: String,
    rules: [Object, Array],
    error: String,
    /**
     * 多个form-item要在同一行显示的时候设置为true
     * 注意：
        1.行内显示时config.js中的errorType设置为1(即消息提示悬浮在输入框上方)
        2.formItem中有label的时候建议指定width和inner_width的值
     * 使用列子：
       <fy-form-item label="生日">
            <fy-form-item prop="table_name" :is_inline="true" :width="'20%'">
                <fy-input type="text" v-model.trim="fieldInfo.table_name" :placeholder="fields.table_name.field_placeholder"></fy-input>
            </fy-form-item>
            <span style="margin-right: 2%;">~~</span>
            <fy-form-item label="生日" prop="table_name" :is_inline="true" :width="'20%'" :inner_width="'60%'">
                <fy-input type="text" v-model.trim="fieldInfo.table_name" :placeholder="fields.table_name.field_placeholder"></fy-input>
            </fy-form-item>
            <span style="margin-right: 2%;">~~</span>
            <fy-form-item prop="table_name" :is_inline="true" :width="'20%'">
                <fy-input type="text" v-model.trim="fieldInfo.table_name" :placeholder="fields.table_name.field_placeholder"></fy-input>
            </fy-form-item>
        </fy-form-item>
     */
    is_inline: {
      type: Boolean,
      default: false
    },
    width: {
      //未解决问题：行内元素有label的情况下width暂时只能是auto
      type: String,
      default: ''
    },
    inner_width: {
      //未解决问题：行内元素有label的情况下width暂时只能是auto
      type: String,
      default: ''
    }
  },
  created () {
    // 注册添加formitem事件
    this.$on('formItem.addChildVc', vc => {
      if (vc) {
        this.childVc = vc
      }
    })
    //初始化自定义样式
    if (this.width) {
      this.style_obj.width = this.width
    }
    if (this.inner_width) {
      this.inner_style_obj.width = this.inner_width
    } else if (this.is_inline && !this.label) {
      this.inner_style_obj.width = '100%'
    }
  },
  mounted () {
    if (this.prop) {
      this.dispatch('FyForm', 'form.addField', [this]) //发送添加formitem对象的信息，触发form中添加formitem的自定义事件
      if (this.childVc && this.childVc.$options) {
        this.styleTypeError =
          this.childVc.$options.componentName == 'FyCheckbox' ||
            this.childVc.$options.componentName == 'FyRadio' ||
            this.childVc.$options.componentName == 'FyInputDate'
            ? 3
            : this.styleTypeError
      }

      //注册事件
      this.$on('el.form.blur', this.onFieldBlur)
      // } else if(this.triggers.indexOf('change') > -1) {
      this.$on('el.form.change', this.onFieldChange)
      this.$on('el.form.focus', this.onFieldFocus)
      // }
      //}
    }
    this.requiredLabelData = this.requiredLabelData ? this.requiredLabelData : this.isRequired
  },
  computed: {
    form () {
      //获取父级form元素
      let parent = this.$parent
      let parentName = parent.$options.componentName
      while (parentName !== 'FyForm') {
        if (parentName === 'FyFormItem') {
          this.isNested = true
        }
        parent = parent.$parent
        parentName = parent.$options.componentName
      }
      return parent
    },
    //从父级form中的model获取对应Value（根据prop）
    fieldValue: {
      cache: false, //作用计算属性不缓存,vue即将取消
      get () {
        const model = this.form.model
        if (!model || !this.prop) {
          return
        }
        return model[this.prop]
      }
    },

    //rule中有required的验证则返回true
    isRequired () {
      let rules = this.getRules()
      let isRequired = false

      if (rules && rules.length) {
        rules.every(rule => {
          if (rule.required && rule.required == true) {
            isRequired = true
            return false
          }
          return true
        })
      }
      return isRequired
    }
  },
  methods: {
    noop () { },
    //清除内容
    resetField () {
      this.validateDisabled = true
      this.isSuccess = false
      this.validateMessage = ''
      this.isShowErrot = false
      //清空value(date组件的清空还有问题)
      this.childVc.resetField()
    },
    //验证方法
    validate (trigger, isFormSubmit, callback = this.noop) {
      this.validateDisabled = false
      const rules = this.getFilteredRule(trigger)
      if (!rules || rules.length === 0) {
        callback()
        return true
      }
      const descriptor = {}
      descriptor[this.prop] = rules
      const validator = new AsyncValidator(descriptor)
      const model = {}
      //日期组件为空时的值是0，这里转成空字符串''，以免影响必填验证
      model[this.prop] =
        this.childVc.$options.componentName == 'FyInputDate' &&
          this.fieldValue == 0
          ? null
          : this.fieldValue
      validator.validate(model, (errors, invalidFields) => {
        if (this.styleTypeError == 3 || !isFormSubmit) {
          this.isShowErrot = !errors ? false : true
        } else {
          this.isShowErrot = false
        }
        //this.isShowErrot = !errors ? false : true;
        this.validateMessage = errors ? errors[0].message : ''
        // if (trigger == 'blur' || trigger == 'change') {
        this.isSuccess = !errors ? true : false
        // }
        if (errors) {
          // console.log('>>>>>>>出错啦~~>>>>>>>')
          // console.log('message:' + errors[0].message)
        }
        callback(this.validateMessage, invalidFields)
        //this.fyForm && this.fyForm.$emit("validate", this.prop, !errors);
      })
    },
    //获取Rules，从父级form组件中取
    getRules () {
      let formRules = this.form.rules
      const selfRules = this.rules
      formRules = formRules ? formRules[this.prop] : []
      //设置自定义验证方法
      formRules = this.customValidator(formRules, this.form.model)
      return [].concat(selfRules || formRules || [])
    },
    //过滤Rules，过滤触发类型不对应的rule
    getFilteredRule (trigger) {
      const rules = this.getRules()
      return rules.filter(rule => {
        if (!rule.trigger || trigger === '') return true
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1
        } else {
          return rule.trigger === trigger
        }
      })
      //.map(rule => objectAssign({}, rule));
    },
    //触发事件
    onFieldBlur (vc) {
      this.validate('blur')
      if (
        this.isShowErrot &&
        (this.styleTypeError == 1 || this.styleTypeError == 2)
      ) {
        this.isShowErrot = false
      }
    },
    //Change触发事件还有问题
    onFieldChange (vc) {
      if (this.validateDisabled) {
        this.validateDisabled = false
        return
      }
      this.validate('change')
    },
    onFieldFocus (vc) {
      this.validate('focus')
    }
  },
  beforeDestroy () {
    this.dispatch('ElForm', 'form.removeField', [this])
  }
}
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>





// WEBPACK FOOTER //
// src/components/form/formItem.vue